import { GenderIdentityState, GenderIdentity } from './types';
import { GenderIdentityActionTypes, ADD_GENDER_IDENTITY, REMOVE_GENDER_IDENTITY,REINIT} from './actions';

const initialState: GenderIdentityState = {
    list: [],
};

// Factory function version
export const genderIdentityReducer = (context?: any) => (
    state = initialState,
    action: GenderIdentityActionTypes
): GenderIdentityState => {
    switch (action?.type) {
        case ADD_GENDER_IDENTITY: {
            const filtered = state.list.filter((item: any) => item.patientid !== action.payload.patientid);
            return {
                ...state,
                list: [...filtered, action.payload],
            };
        }
        case REMOVE_GENDER_IDENTITY: {
            return {
                ...state,
                list: state.list.filter(item => item.patientid !== action.payload),
            };
        }
        case REINIT: {
            return initialState;
        }
        default:
            return state;
    }
};